import { render, staticRenderFns } from "./SignatureCanvas.vue?vue&type=template&id=f2beb1cc&"
import script from "./SignatureCanvas.vue?vue&type=script&lang=js&"
export * from "./SignatureCanvas.vue?vue&type=script&lang=js&"
import style0 from "./SignatureCanvas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports